import React, { useState } from 'react'
import LandingHeader from '../landing-page/LandingHeader/LandingHeader'
import "./ClaimsPage.scss";
import ConnectWallet from './ConnectedWallet/ConnectWallet';
import { Dialog } from '@mui/material';
import { ClaimsDelegateDialog } from '../../dialogs';

function ClaimsPage() {
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [isDelegateDialog, setDelegateDialog] = useState<boolean>(false);

  return (
    <div className="claimsPage">
      <LandingHeader />
      {!isWalletConnected ? (
        <div className="claimsPage__content">
          <h1>
            Lighthouse <br /> Airdrop Is Live !!
          </h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            <br /> Ut enim ad minim veniam
          </p>
          <div className="buttonContainer">
            <button className="fillBtn__blue" style={{ margin: '0px' }} onClick={() => { setIsWalletConnected(true) }}>Check Your eligibility</button>
            <button className="fillBtn__blue" style={{ background: '#4F4F4F' }}>Learn More</button>
          </div>
        </div>
      ) : (
        <ConnectWallet setDelegateDialog={setDelegateDialog} />
      )}
      <Dialog
        open={isDelegateDialog}
        onClose={() => { setDelegateDialog(false) }}
      >
        <ClaimsDelegateDialog />
      </Dialog>
    </div>
  )
}

export default ClaimsPage